<template>
  <div class="coming-soon">
    <div class="coming-soon-icon">📚</div>
    <h2 class="coming-soon-title">大旅行调查题目</h2>
    <p class="coming-soon-text">
      本部分将整理展示东亚同文书院学生在中国各地进行调查研究的题目、内容概要及相关成果。
      正在紧张筹备中，即将上线！
    </p>
  </div>
</template>

<script>
export default {
  name: 'TravelTopics'
}
</script>

<style scoped>
.coming-soon {
  text-align: center;
  padding: 50px 20px;
}

.coming-soon-icon {
  font-size: 5rem;
  color: var(--primary-color);
  margin-bottom: 20px;
}

.coming-soon-title {
  font-size: 1.8rem;
  color: var(--primary-dark);
  margin-bottom: 15px;
}

.coming-soon-text {
  font-size: 1.1rem;
  color: var(--secondary-color);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .coming-soon-icon {
    font-size: 3.5rem;
  }

  .coming-soon-title {
    font-size: 1.5rem;
  }

  .coming-soon-text {
    font-size: 1rem;
  }
}
</style>